/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A free online stopwatch with lap times. Start, stop, lap and reset — accurate to a hundredth of a second. No signup, works in your browser.`)
};

const es_timer_stopwatch_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronómetro online gratis con tiempos de vuelta. Inicia, detén, marca vueltas y reinicia — preciso hasta la centésima de segundo. Sin registro.`)
};

const de_timer_stopwatch_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine kostenlose Online-Stoppuhr mit Rundenzeiten. Starten, stoppen, Runde nehmen und zurücksetzen — genau auf die Hundertstelsekunde. Keine Anmeldung, läuft im Browser.`)
};

const nl_timer_stopwatch_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een gratis online stopwatch met rondetijden. Start, stop, noteer een ronde en reset — nauwkeurig tot op een honderdste seconde. Geen aanmelding nodig.`)
};

const fr_timer_stopwatch_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronomètre en ligne gratuit avec temps au tour. Démarrez, arrêtez, enregistrez un tour et réinitialisez — précis au centième de seconde. Sans inscription, dans votre navigateur.`)
};

const it_timer_stopwatch_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un cronometro online gratuito con tempi sul giro. Avvia, ferma, segna il giro e ripristina — preciso al centesimo di secondo. Nessuna registrazione, funziona nel browser.`)
};

const pt_br2_timer_stopwatch_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronômetro online grátis com tempos de volta. Inicie, pare, marque voltas e redefina — precisão de centésimos de segundo. Sem cadastro.`)
};

const pt_timer_stopwatch_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um cronómetro online gratuito com tempos de volta. Inicie, pare, registe voltas e reponha — com precisão de centésimos de segundo. Sem registo, funciona no navegador.`)
};

const ja_timer_stopwatch_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラップタイム計測ができる無料オンラインストップウォッチ。スタート、ストップ、ラップ、リセットに対応し、1/100秒単位で正確に計測。登録不要でブラウザ上で動作します。`)
};

const zh_timer_stopwatch_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线秒表，支持计圈。开始、停止、计圈、重置 — 精确到百分之一秒。无需注册，可在浏览器中使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_meta_description", locale)
	if (locale === "en") return en_timer_stopwatch_meta_description(inputs)
	if (locale === "es") return es_timer_stopwatch_meta_description(inputs)
	if (locale === "de") return de_timer_stopwatch_meta_description(inputs)
	if (locale === "nl") return nl_timer_stopwatch_meta_description(inputs)
	if (locale === "fr") return fr_timer_stopwatch_meta_description(inputs)
	if (locale === "it") return it_timer_stopwatch_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_meta_description(inputs)
	if (locale === "pt") return pt_timer_stopwatch_meta_description(inputs)
	if (locale === "ja") return ja_timer_stopwatch_meta_description(inputs)
	return zh_timer_stopwatch_meta_description(inputs)
};